videojs.addLanguage('en', {
	"Moments settings": "Moments settings",
	"Moments": "Highlights",
	"Select moments visible over timeline": "Select highlights visible over timeline",
	"Accept moments settings": "Accept"
});
